import React from "react";
import FontAwesome from "react-fontawesome";
import autoBind from "react-autobind";
import _ from "lodash";

import { markdownToHtml } from "../../utils/markupUtils";
import PlayerCheckbox from "./PlayerCheckbox";
import withPlayerItemHoc from "./PlayerItemHoc";
import DoneButton from "./DoneButton";
/*
	 Generic read-only version of a player component 
 */
class PlayerMultiChoice extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		autoBind(this);
	}

	render() {
		if (this.props.readOnly) {
			return this.renderReadOnly();
		} else {
			return this.renderEditable();
		}
	}

	onClick(event, value, label) {
		const item = this.props.item;
		let newArray = item.value.slice();

		if (event.target.checked) {
			newArray.push({
				value: value,
				label: label
			});
		} else {
			newArray = this.removeItem(newArray, value);
		}

		if (this.props.onChange) { this.props.onChange(newArray); }
	}

	onSubmit() {
		if (this.props.onSubmit) { this.props.onSubmit(this.props.item.value.slice()); }
	}

	removeItem(arr, value) {
		let result = [];

		_.forEach(arr, item => {
			if (item.value !== value) {
				result.push(item);
			}
		});

		return result;
	}


	isChecked(arr, value) {
		let result = false;

		if (arr && _.isArray(arr)) {
			_.forEach(arr, item => {
				if (item.value === value) {
					result = true;
				}
			});
		}
		return result;
	}

	renderReadOnly() {
		let self = this;
		const { item, getImage, getVideo, getPdf } = this.props;

		let idPostfix = this.props.getActivityItemPath("-");

		const rows = item.choiceItems.map((choiceItem, i) => {
			let check;

			//add dynamic styles if present
			if (choiceItem.properties && choiceItem.properties !== "") {
				let properties = choiceItem.properties;

				let propertiesObject = JSON.parse(properties);
				Object.assign(choiceItem, propertiesObject);
			}

			if (choiceItem.style) {
				choiceItem.style.justifyContent = choiceItem.style.textAlign === "right" ? "flex-end" : "flex-start";
			}

			let checkboxSize = "24px";

			if (self.isChecked(item.value, choiceItem.value)) {
				check = <FontAwesome fixedWidth={true} style={{ fontSize: checkboxSize, margin: 10 }} name="check-square-o" />;
			} else {
				check = <FontAwesome fixedWidth={true} style={{ fontSize: checkboxSize, margin: "10px 10px 10px 8px" }} name="square-o" />;
			}

			let style = { display: "flex", flexDirection: "row", width: "100%", alignItems: "center" }

			const idKey = "player-check-item-" + i + "-" + idPostfix;
			return (<div key={idKey} style={_.merge(style, choiceItem.style)}>
				{check}
				<div>{choiceItem.label}</div>
			</div>);
		});

		let rowsContainer;

		if (item.backgroundImage) {
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}>
				<div style={{ backgroundImage: `url(${item.backgroundImage})` }} className="player-item-background-image">
					{rows}
				</div>
			</div>;

		} else {
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
				{rows}
			</div>
		}
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%", overflow: "none" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { readOnlyLinks: true })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { readOnlyLinks: true })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					{rowsContainer}
				</div>
			</div>
		);
	}

	renderEditable() {
		const self = this;

		const { item, getImage, getVideo, getPdf, disabled, listIndex, sectionIndex, itemIndex } = this.props;

		let idPostfix = this.props.getActivityItemPath("-");
		let rows = item.choiceItems.map((choiceItem, idx) => {
			const idKey = "player-check-item-" + idx + "-" + idPostfix;
			let checked = self.isChecked(item.value, choiceItem.value);

			//add dynamic styles if present
			if (choiceItem.properties && choiceItem.properties !== "") {
				let properties = choiceItem.properties;

				let propertiesObject = JSON.parse(properties);
				Object.assign(choiceItem, propertiesObject);
			}
			let inputSize = 30; // use default
			if (choiceItem.style) {
				choiceItem.style.justifyContent = choiceItem.style.textAlign === "right" ? "flex-end" : "flex-start";
				inputSize = choiceItem.style.inputSize ? choiceItem.style.inputSize : 30;
			}

			return (
				<PlayerCheckbox size={inputSize} key={idKey} id={idKey} checked={checked} onClick={(e) => self.onClick(e, choiceItem.value, choiceItem.label)} label={choiceItem.label} disabled={disabled} style={choiceItem.style} />
			);
		});

		let rowsContainer;

		if (item.backgroundImage) {
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom: "12px", alignItems: "center" }}>
				<div style={{ backgroundImage: `url(${item.backgroundImage})` }} className="player-item-background-image">
					{rows}
				</div>
			</div>;

		} else {
			rowsContainer = <div style={{ display: "flex", flexDirection: "column", width: "100%", marginBottom: "12px" }}>
				{rows}
			</div>
		}
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		return (
			<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
				<div style={{ width: "100%", overflowX: "none" }}>
					<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
					<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
					{getImage()}
					{getVideo()}
					{getPdf()}
					{rowsContainer}
					{!disabled && <DoneButton onSubmit={this.onSubmit} />}
				</div>
			</div>
		);
	}
}

export default withPlayerItemHoc(PlayerMultiChoice);